import { endpoint } from "./endpoint";
import textLiterals from "../assets/data/config.json";
const Axios = require("axios");

export async function getTextLiteral() {
  return process.env.NODE_ENV === "production"
    ? Axios.get(endpoint.concat("config.json"))
        .then((result) => {
          return result.data;
        })
        .catch((err) => {
          console.log("err :>> ", err);
          return {};
        })
    : new Promise((res, rej) => res(textLiterals));
}

export function getTopDisclaimer(textLiterals){
  return textLiterals.topDisclaimer;
}

export function getMapTitle(textLiterals) {
  return textLiterals.mapTitle ?? "";
}

export function getMapDisclaimer(textLiterals) {
  return textLiterals.mapDisclaimer ?? "";
}

export function getGraphTitle(textLiterals) {
  return textLiterals.graphTitle ?? "";
}

export function getGraphAxisLabels(textLiterals) {
  return [textLiterals.graphXAxis ?? "", textLiterals.graphYAxis ?? ""];
}

export function getTooltipName(variant, textLiterals) {
  return textLiterals.tooltipName[variant];
}

export function getVariantName(variant, textLiterals) {
  return textLiterals.variantName[variant];
}

export function getLatestStrainTableTitle(textLiterals) {
  return textLiterals.latestStrainTableTitle;
}

export function getLatestStrainBySubmissionDateTableTitle(textLiterals) {
  return textLiterals.latestStrainBySubmissionDateTableTitle;
}

export function getLatestStrainTableHeaders(textLiterals) {
  return textLiterals.latestStrainTableHeaders;
}

export function getLatestStrainBySubmissionDateTableHeaders(textLiterals) {
  return textLiterals.latestStrainBySubmissionDateTableHeaders;
}

export function getLatestStrainDisclaimer(textLiterals) {
  return textLiterals.latestStrainTableDisclaimer;
}
export function getCountryTableTitle(textLiterals) {
  return textLiterals.countryCountTitle;
}

export function getCountryTableHeaders(variant, textLiterals) {
  const variantName = getTooltipName(variant, textLiterals);
  const headerValues = textLiterals.countryCountHeaders;
  return headerValues.map((value) => {
    if (value.Header === "Total #") {
      return { Header: value.Header + variantName, accessor: value.accessor };
    } else if (value.Header === "# in past 4 weeks") {
      return {
        Header: value.Header.slice(0, 1) + variantName + value.Header.slice(1),
        accessor: value.accessor,
      };
    } else if (value.Header === "% in past 4 weeks") {
      const toReturn = {
        Header: value.Header.slice(0, 1) + variantName + value.Header.slice(1),
        accessor: value.accessor,
      };
      return toReturn;
    } else {
      return value;
    }
  });
}

export function getCountryTableDisclaimer(textLiterals) {
  return textLiterals.countryCountDisclaimer;
}

export function getVariantOptions(textLiterals) {
  return textLiterals.variantOptions;
}

export function getDisclaimerBeforeTree(textLiterals) {
  return textLiterals.disclaimerBeforeTree;
}

export function getDisclaimerAfterTree(textLiterals) {
  return textLiterals.disclaimerAfterTree;
}

export function getIFrameData(variant, textLiterals) {
  return textLiterals.iFrame[variant];
}

export function getPDBStructureConfig(variant, textLiterals){
  return textLiterals.PDBStructure[variant];
}

export function getWeekRegion2percDateStart(variant, textLiterals){
  return textLiterals.weekRegion2percDateStart[variant];
}

export function getLineageNameIn3DStructDesc(variant,textLiterals){
  return textLiterals.linageNameIn3DStructDesc[variant];
}

export function getTopDisclaimerIn3DStructModal(variant,textLiterals){
  return textLiterals.topDisclaimerIn3DStructModal;
}